import React, { useCallback, useEffect, useRef, useState } from 'react';
import './App.css';

import TGUIRoute from "./TGUIRoute";
import TGUITimeline from "./TGUITimeline";
import * as geolib from "geolib";

const icao = "KBOS";

// const aircraft = [
//   { callsign: "EGF050", eta: 2.5 },
//   { callsign: "AAL652", eta: 4.5, type: "5", delay: 4 },
//   { callsign: "EGF894", eta: 7 },
//   { callsign: "EGF586", eta: 7 },
//   { callsign: "ASE926", eta: 17.8, type: "S", delay: 3 },
//   { callsign: "NTS172", eta: 17.8, type: "S", isFrozen: false, delay: 1 },
//   { callsign: "DAL1991", eta: 20.5, type: "H", hasRadarTrack: false, isFrozen: false },
// ];

function App() {
  const [aircraft, setAircraft] = useState([]);
  const [airport, setAirport] = useState();
  const [clockLabel, setClockLabel] = useState();
  const [route, setRoute] = useState([]);
  // [{"identifier":"MERIT","position":{"latitude":41.38195,"longitude":-73.1374305555556}},{"identifier":"RUIZE","restriction":{"minAltitude":21000,"maxAltitude":23000},"position":{"latitude":41.4793416666667,"longitude":-72.2094277777778}},{"identifier":"AWLIN","restriction":{"minAltitude":17000},"position":{"latitude":41.5562444444444,"longitude":-71.9991583333333}},{"identifier":"BANKI","restriction":{"minAltitude":16000},"position":{"latitude":41.5956638888889,"longitude":-71.867675}},{"identifier":"ROBUC","restriction":{"minAltitude":12000,"maxAltitude":19000,"minSpeed":260,"maxSpeed":260},"position":{"latitude":41.6789194444444,"longitude":-71.5851166666667}},{"identifier":"PROVI","restriction":{"minAltitude":11000},"position":{"latitude":41.7237388888889,"longitude":-71.4317138888889}},{"identifier":"JOODY","position":{"latitude":41.7853805555556,"longitude":-71.2875638888889}},{"identifier":"KRANN","restriction":{"minAltitude":11000,"maxAltitude":12000,"minSpeed":250,"maxSpeed":250},"position":{"latitude":41.8551916666667,"longitude":-71.1234611111111}},{"identifier":"CRADL","restriction":{"minAltitude":8000,"maxAltitude":10000},"position":{"latitude":42.0102444444444,"longitude":-70.7632083333333}},{"identifier":"KLEBB","restriction":{"minAltitude":8000,"maxAltitude":8000,"minSpeed":250,"maxSpeed":250},"position":{"latitude":42.1084111111111,"longitude":-70.6161333333333}},{"identifier":"ETHYN","restriction":{"minAltitude":5000,"maxAltitude":5000,"minSpeed":250,"maxSpeed":250},"position":{"latitude":42.3258694444445,"longitude":-70.5554416666667}},{"identifier":"PTRIK","restriction":{"minAltitude":5000,"maxAltitude":5000,"minSpeed":220,"maxSpeed":220},"position":{"latitude":42.5272888888889,"longitude":-70.8206333333333}},{"identifier":"TAALE","restriction":{"minAltitude":5000,"maxAltitude":5000,"minSpeed":210,"maxSpeed":210},"heading":35,"position":{"latitude":42.6262638888889,"longitude":-70.7718722222222}}]
  const [selectedAircraft, setSelectedAircraft] = useState();
  const [zoom, setZoom] = useState(1);

  const lastDataRefresh = useRef();

  useEffect(() => {
    async function loadAircraft() {
      console.log("Loading aircraft...");
      const [airportResponse, arrivalsResponse] = [
        await fetch(`https://avcloud.now.sh/api/airports/${icao}`),
        await fetch(`https://avcloud.now.sh/api/vatsim/data/airports/${icao}/aircraft/arrivals`)
      ];
      const [airport, arrivals] = [await airportResponse.json(), await arrivalsResponse.json()];
      setAirport(airport);
      const dataString = JSON.stringify(arrivals);
      if (lastDataRefresh.current === dataString) {
        return;
      }
      lastDataRefresh.current = dataString;
      const unsortedAircraft = arrivals
        .filter(aircraft => {
          return aircraft.groundspeed >= 40;
        })
        .map((aircraft, i) => {
          const distanceMeters = geolib.getDistance(aircraft.position, airport.position);
          const distance = distanceMeters / 1852;
          const minutes = distance / (aircraft.groundspeed || 1) * 60;
          return {
            ...aircraft,
            callsign: aircraft.callsign,
            eta: minutes,
            type: aircraft.type && aircraft.type.weightCategory
          }
        });
      setAircraft(unsortedAircraft.sort((a, b) => {
        return a.eta - b.eta;
      }));
    }
    loadAircraft();
    setInterval(() => {
      loadAircraft();
    }, 15 * 1000);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAircraft(aircraft.map(aircraft => {
        return {
          ...aircraft,
          eta: aircraft.eta - (5 / 60)
        };
      }).filter(aircraft => {
        return aircraft.eta > 0;
      }));
    }, 5 * 1000);
    return () => clearTimeout(timeout);
  }, [aircraft]);

  useEffect(() => {
    let prevZoom = 1;
    window.addEventListener("mousewheel", e => {
      const unclipped = prevZoom * ((100 + e.deltaY) / 100);
      prevZoom = Math.min(Math.max(unclipped, 1), 2);
      setZoom(prevZoom);
    });
  }, []);

  useEffect(() => {
    setInterval(() => {
      const date = new Date();
      const hours = "0" + date.getUTCHours();
      const minutes = "0" + date.getUTCMinutes();
      const seconds = "0" + date.getUTCSeconds();
      const label =`${hours.substr(-2)}${minutes.substr(-2)}:${seconds.substr(-2)}`;
      setClockLabel(label);
    }, 1000);
  }, []);

  useEffect(() => {
    const loadAndSetRoute = async () => {
      if (!selectedAircraft || !airport) {
        return;
      }
      console.log("Loading route...");
      const routeString = selectedAircraft.flightPlan && selectedAircraft.flightPlan.route;
      if (!routeString) {
        console.log("No route found");
        setRoute([]);
        return;
      }
      const arrivalMatch = routeString.match(/([A-Z]{3}|[A-Z]{5})? ([A-Z]{3}|[A-Z]{5})\d$/);
      const arrivalString = arrivalMatch && arrivalMatch[0];
      if (!arrivalString) {
        console.log("No arrival found");
        setRoute([]);
        return;
      }
      const routeQuery = `${arrivalString} 4R`;
      const routeResponse = await fetch(`https://avcloud.now.sh/api/route?q=${routeQuery}`);
      const route = await routeResponse.json();
      if (!route) {
        console.log("No waypoints found");
        setRoute([]);
        return;
      }
      console.log("Route found!");
      setRoute([
        ...route,
        {
          identifier: airport.icao,
          position: airport.position
        }
      ]);
    };
    loadAndSetRoute();
  }, [selectedAircraft, airport]);

  const selectAircraft = useCallback((callsign) => {
    const selectedAircraft = aircraft.find(aircraft => {
      return aircraft.callsign === callsign;
    });
    if (!selectAircraft) {
      return;
    }
    setSelectedAircraft(selectedAircraft);
  }, [aircraft]);

  return (
    <div className="container">
      <div className="menu-bar">
        <div className="clock dim">
          {clockLabel && clockLabel}
          {!clockLabel && "----:--"}
        </div>
      </div>
      <div className="tgui-container">
        {/* <TGUITimeline /> */}
        <TGUIRoute
          route={route}
        />
        <TGUITimeline
          aircraft={aircraft}
          zoom={zoom}
          meterFix={icao}
          selectAircraft={selectAircraft}
        />
      </div>
    </div>
  );
}

export default App;
